const __WEBPACK_NAMESPACE_OBJECT__ = flarum.reg.get('fof-upload', 'forum/components/FileManagerModal');